import React from 'react'
import { Box, Typography } from '@mui/material'
import MoveReplaceToggle from './MoveReplaceToggle'

interface EdgeLineChoiceProps {
  name?: string
  fromCorner: string
  toCorner: string
  replaced: boolean
  onChange: (replace: boolean) => void
  t: (key: string, options?: object) => string
}

// One line at a grown edge, told by its grid place: the corner it leaves and the new corner.
const EdgeLineChoice: React.FC<EdgeLineChoiceProps> = ({ name, fromCorner, toCorner, replaced, onChange, t }) => (
  <>
    <Box minWidth={0}>
      <Typography fontSize={14} fontWeight={700}>
        {name}
        {fromCorner && toCorner && (
          <Typography component="span" fontSize={12} fontWeight={600} color="text.secondary" ml={1}>
            {t('revision-edge-line-path', { from: fromCorner, to: toCorner })}
          </Typography>
        )}
      </Typography>
    </Box>
    <MoveReplaceToggle
      replaced={replaced}
      onChange={onChange}
      moveLabel={t('revision-expand-line-move')}
      replaceLabel={t('revision-expand-line-replace')}
    />
  </>
)

export default EdgeLineChoice
